import { render, staticRenderFns } from "./PocketBindForm.vue?vue&type=template&id=53a5c710"
import script from "./PocketBindForm.vue?vue&type=script&lang=js"
export * from "./PocketBindForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports